import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Fabbricato } from 'src/app/models/fabbricato';
import { FabbricatoService } from 'src/app/services/fabbricato.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { FabbricatiFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'fabbricati',
  templateUrl: './fabbricati.component.html',
  styleUrls: ['./fabbricati.component.scss']
})
export class FabbricatiComponent implements OnInit {

  headingText: string = 'Fabbricati';


  relations: string[] = [
    'comune', 'comune.provincia', 'classe_fabbricato', 'tipologia_costruttiva',
    'stato_manutenzione_generale', 'stato_manutenzione_impianto_idrico_igenico',
    'amministratore',
  ];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',
        type: 'link',
        href: (model) => model?.id,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Amministratore',
        internalName: 'amministratore',
        displayFunction: (fab: Fabbricato) => fab?.amministratore?.humanIdentifier,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Indirizzo',
        internalName: 'fullAddress',
        sortDisabled: true,
      }
    ),
  ];
  constructor(public fabbricatoService: FabbricatoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<FabbricatiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un fabbricato';
    }
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (fabbricato: Fabbricato) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il fabbricato ${fabbricato.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.fabbricatoService.delete(fabbricato);
          this.toast.success('Fabbricato eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione fabbricato fallita.", "Errore!");
    }
  }



  editFunction = async (fabbricato: Fabbricato) => {
    try {
      let dialogRef = this.dialog.open(FabbricatiFormComponent, { data: fabbricato });
      dialogRef.afterClosed().subscribe(async (data: Fabbricato) => this.updateDataSource());

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica fabbricato fallita.", "Errore!");
    }
  }

  add() {
    let addDialogRef = this.dialog.open(FabbricatiFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(fabbricato?: Fabbricato) {
    this.updateDataSource();
  }




}
